/*
This handler detects when a user comes via a URL with a code therein, and then hides the discount code input to prevent overwriting promo discounts / clashing combo discounts / free gift codes in conjunction with other promos
*/

window.URLDiscountManager = (function () {
  let debug = false;

  function log(...args) {
    if (debug) {
      console.log('[URLDiscountManager]', ...args);
    }
  }

  function hasURLDiscount() {
    const cookies = document.cookie.split(';');
    const discountCookie = cookies.find(c => c.trim().startsWith('discount_code='));

    if (!discountCookie) return false;

    const value = discountCookie.split('=')[1];
    return value && value !== 'undefined' && value.trim().length > 0;
  }

  function manageDiscountInput() {
    log('=== manageDiscountInput called ===');

    const discountInputWrapper = document.querySelector('[data-rebuy-component="discount-input"]');
    if (!discountInputWrapper) {
      log('Input wrapper not found yet');
      return;
    }

    const hasURL = hasURLDiscount();
    log('Has URL discount:', hasURL);

    if (hasURL) {
      discountInputWrapper.style.setProperty('display', 'none', 'important');
      log('Set display:none with !important');

      if (!discountInputWrapper._observer) {
        const observer = new MutationObserver(() => {
          if (hasURLDiscount() && discountInputWrapper.style.display !== 'none') {
            log('Rebuy tried to show input, forcing hide again');
            discountInputWrapper.style.setProperty('display', 'none', 'important');
          }
        });

        observer.observe(discountInputWrapper, {
          attributes: true,
          attributeFilter: ['style'],
        });
        discountInputWrapper._observer = observer;
        log('MutationObserver attached');
      }

      if (!document.getElementById('url-discount-notice')) {
        const footer = document.querySelector('[data-rebuy-cart-anchor="footer"]');
        if (footer) {
          const notice = document.createElement('div');
          notice.id = 'url-discount-notice';
          notice.style.cssText = `
            padding-bottom: 0px;
            text-align: center;
            color: #666;
            font-size: 13px;
            font-style: italic;
            background-color: #f5f5f5;
          `;
          notice.textContent = '¡Código de descuento ya aplicado!';
          footer.insertBefore(notice, footer.firstChild);
          log('Notice added');
        }
      }
    } else {
      discountInputWrapper.style.setProperty('display', '', '');

      if (discountInputWrapper._observer) {
        discountInputWrapper._observer.disconnect();
        delete discountInputWrapper._observer;
        log('Observer removed');
      }

      const notice = document.getElementById('url-discount-notice');
      if (notice && notice.parentNode) {
        notice.remove();
        log('Notice removed');
      }
    }
  }

  return {
    init: function () {
      if (!window.RebuyEventManager) {
        console.error('[URLDiscountManager] RebuyEventManager not available');
        return this;
      }

      window.RebuyEventManager.on('cart:show', manageDiscountInput)
        .on('cart:change', manageDiscountInput)
        .on('cart:ready', manageDiscountInput);

      window.addEventListener('pageshow', manageDiscountInput);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          manageDiscountInput();
        }
      });

      log('Initialized');
      return this;
    },

    refresh: function () {
      manageDiscountInput();
      return this;
    },

    debug: function (enabled) {
      debug = enabled;
      log('Debug logging', enabled ? 'enabled' : 'disabled');
      return this;
    },
  };
})();
